import { cn } from '@/lib/utils';
import { endOfMonth, format, isEqual, isPast, isToday, startOfMonth } from 'date-fns';
import { FC } from 'react';

interface DayProps {
  day: Date;
  viewing: Date;
  selected: Date[];

  isSelected: (date: Date) => boolean;
  inRange: (date: Date, min: Date, max: Date) => boolean;

  onClick: () => void;
  excludeDates?: string[];
  excludePastDates?: boolean;
  disabledPredicate?: (date: Date) => boolean;
}

export const Day: FC<DayProps> = ({
  day,
  selected,
  viewing,
  isSelected,
  inRange,
  onClick,
  excludeDates,
  excludePastDates,
  disabledPredicate
}) => {
  return (
    <div
      style={{ aspectRatio: '1' }}
      className={cn(
        'flex items-center justify-center cursor-pointer my-0.5',
        // Rounds the left side if is the first selected (or only)
        isSelected(day) && isEqual(day, selected[0]) ? 'rounded-l-full' : null,

        // Rounds the right side if is the last selected (or only)
        isSelected(day) && isEqual(day, selected[selected.length - 1]) ? 'rounded-r-full' : null,

        // Is not in the current month being viewed
        !inRange(day, startOfMonth(viewing), endOfMonth(viewing)) ? 'text-secondary-std' : null,

        // Subtle highlight of today when today is not selected
        isToday(day) && !isSelected(day) ? 'text-blue-700 font-semibold' : null,

        // Boldly highlight & provide hover feedback for currently selected date
        isSelected(day) ? 'bg-blue-700 hover:bg-blue-800 text-white font-bold' : null,

        !isSelected(day) ? 'hover:bg-gray-100 hover:text-gray-800 hover:rounded-full' : null,

        excludeDates?.includes(day.toDateString()) ? 'pointer-events-none	text-secondary-std opacity-20' : null,

        excludePastDates && isPast(day) ? 'pointer-events-none	text-secondary-std opacity-20' : null,
        
        disabledPredicate?.(day) ? 'pointer-events-none text-secondary-std opacity-20' : null
      )}
      key={`${day}`}
      onClick={onClick}
    >
      <p>{format(day, 'd')}</p>
    </div>
  );
};
